<div class="list-container">
  <app-payment-reversal-filters
    class="sticky-form-container"
    [(filters)]="filters"
    [isLoading]="isLoading"
    [statusTabs]="statusTabs"
    [(statusTab)]="statusTab"
    [(showMobileFilters)]="showMobileFilters"
    [hasResults]="results.items?.length > 0"
    [(noSearches)]="noSearches"
    (search)="search($event)"
    [selectedIds]="selectedIds"
    [eventId]="eventId"
    (refundClicked)="sendToRefund()"
    (refundAllClicked)="sendEventToRefund()"
  ></app-payment-reversal-filters>
  <ng-container *ngIf="!isLoading && results.items.length && !showMobileFilters">
    <mat-card appearance="outlined">
      <app-pagination *ngIf="!utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total" [onTop]="true" (pageChange)="search($event)"></app-pagination>
      <div class="flex">
        <mat-form-field class="dynamic-width">
          <mat-label>{{'general.api_search_display' | translate}}:</mat-label>
          <mat-select [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage()">
            <mat-select-trigger>{{pageSize}}</mat-select-trigger>
            <mat-option *ngFor="let pageSizeValue of pageSizeOptions" [value]="pageSizeValue">
              {{pageSizeValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="!utilService.isMobile">
        <app-data-table [(data)]="results.items" [(config)]="dataTableConfig" [(selected)]="selectedIds" [(clickable)]="clickable"></app-data-table>
        <app-pagination [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
      </ng-container>
      <ng-container *ngIf="utilService.isMobile">
        <hr class="slim">
        <div>
          <div class="listing-header" *ngIf="clickable?.length > 0">
            <mat-checkbox (change)="toggleAll($event)"
                          [checked]="areAllSelected()" [indeterminate]="areSomeSelected()" [disabled]="!clickable.length"></mat-checkbox>
            <span class="medium">{{ 'general.api_transactions_select_all' | translate }}</span>
          </div>
          <div class="listing-block" *ngFor="let trx of results.items">
            <div class="header-block flex space-between bottom-spacer">
              <div class="flex">
                <div *ngIf="clickable.length">
                  <mat-checkbox (change)="toggle($event, trx.id)"
                                [checked]="isSelected(trx.id)"></mat-checkbox>
                </div>
                <div>
                  <div class="heading-5 no-margin">
                    {{'general.api_payment_reversal_order_confirmation' | translate}} {{trx.orderConfirmation}}
                  </div>
                </div>
              </div>
            </div>
            <table class="mobile-max-width bottom-spacer">
              <tbody>
                <tr>
                  <td class="bold">{{'general.api_payment_reversal_refund_date' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableRefundDate; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="bold">{{'general.api_payment_reversal_refund_transaction_id' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableRefundTransaction; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="bold">{{'general.api_payment_reversal_client' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableClient; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="bold">{{'general.api_payment_reversal_event' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableEvent; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="bold">{{'general.api_payment_reversal_client_account' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableClientAccount; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr *ngIf="pendingOrCompletedOrFailed">
                  <td class="bold">{{'general.api_payment_reversal_sender' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableSender; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr *ngIf="completedOrFailed">
                  <td class="bold">{{'general.api_payment_reversal_response' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableResponse; context: {item: trx}"></ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="bold">{{'general.api_payment_reversal_table_total' | translate}}</td>
                  <td class="align-right break-all">
                    <ng-container *ngTemplateOutlet="tableTotal; context: {item: trx}"></ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr class="no-margin">
          </div>
        </div>
      </ng-container>
    </mat-card>
    <app-pagination *ngIf="utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total" (pageChange)="search($event)"></app-pagination>
  </ng-container>

  <app-loader [loading]="isLoading"></app-loader>
</div>

<ng-template #tableSender let-item="item">
  {{item.senderEmail}}
</ng-template>

<ng-template #tableRefundTransaction let-item="item">
  {{item.refundTransactionId}}
</ng-template>

<ng-template #tableTotal let-item="item">
  <b>{{item.totalAmount | price}}</b>
</ng-template>

<ng-template #tableClient let-item="item">
  <b>{{item.client?.firstName}} {{item.client?.lastName}}</b>
  <div>{{item.client?.email || '-'}}</div>
</ng-template>

<ng-template #tableClientAccount let-item="item">
  {{item.accountNumber || item.accountOwnerName}}
</ng-template>

<ng-template #tableRefundDate let-item="item">
  {{item.refundDate | moment}}
</ng-template>

<ng-template #tableEvent let-item="item">
  <span class="title">{{item.eventName | translateValue}}</span>
  <div>{{item.eventDate | period : {tz: item.timezone, hasTimeInPeriod: true} }}</div>
</ng-template>

<ng-template #tableResponse let-item="item">
  {{ item.refundStatusUpdate | moment: {format: viewService.conf.dateTimeFormatWithSeconds} }}
</ng-template>
